var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-modal" }, [
    _c("img", {
      staticClass: "video-modal__placeholder",
      class: {
        "video-modal__placeholder--visible": !_vm.isModalVisible
      },
      attrs: { src: _vm.placeholder }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "video-modal__play",
        class: {
          "video-modal__play--visible": !_vm.isModalVisible
        },
        on: { click: _vm.onClickButton }
      },
      [_vm._v("\n    Play\n  ")]
    ),
    _vm._v(" "),
    _vm.isModalVisible
      ? _c(
          "div",
          {
            staticClass: "video-modal__modal",
            class: { "video-modal__modal--youtube": _vm.isYoutube },
            attrs: { role: "tooltip" }
          },
          [
            _vm.isYoutube
              ? _c(
                  "div",
                  {
                    staticClass:
                      "video-modal__video video-modal__video--youtube"
                  },
                  [
                    _c("YouTubePlayer", {
                      attrs: { id: _vm.youtubeVideoId, "auto-play": true }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isYoutube
              ? _c("video", {
                  ref: "video",
                  staticClass: "video-modal__video",
                  attrs: { src: _vm.video, autoplay: "" }
                })
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }